import setupDeprecationWorkflow from "ember-cli-deprecation-workflow";

/**
 * Docs: https://github.com/ember-cli/ember-cli-deprecation-workflow
 */
setupDeprecationWorkflow({
  /**
   * Unhandled deprecations throw instead of warning, so anything new fails the
   * moment it appears rather than accumulating unnoticed until the API is
   * removed in a later major. Every entry below is a deliberate exception.
   *
   * Only affects development and test builds — production strips deprecations
   * out entirely, so this can never throw in front of a user.
   */
  throwOnUnhandled: true,
  workflow: [
    /*
     * To regenerate this list, run the app for a while (or run the test suite),
     * then run this in the browser console (and copy the handlers here):
     *
     * deprecationWorkflow.flushDeprecations()
     */
  ],
});
